import { render, staticRenderFns } from "./IpActions.vue?vue&type=template&id=37d81bb3"
import script from "./IpActions.vue?vue&type=script&lang=js"
export * from "./IpActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports